import type { ReactNode } from 'react';

import type { RenderStackEntry } from './RenderStackManager';
import { ViewHolder } from './ViewHolder';
import type { RVLayout } from './layout-managers/LayoutManager';

export interface ViewHolderCollectionProps {
  stack: ReadonlyArray<RenderStackEntry>;
  renderItemForIndex: (index: number) => ReactNode;
  getLayout: (index: number) => RVLayout | null;
  onMeasure: (
    index: number,
    dimensions: { width: number; height: number },
  ) => void;
  ItemSeparatorComponent?: () => ReactNode;
  isLastIndex: (index: number) => boolean;
  inverted?: boolean;
  snapAlignment?: 'start' | 'center' | 'end';
}

export function ViewHolderCollection({
  stack,
  renderItemForIndex,
  getLayout,
  onMeasure,
  ItemSeparatorComponent,
  isLastIndex,
  inverted,
  snapAlignment,
}: ViewHolderCollectionProps) {
  return (
    <>
      {stack.map(entry => {
        const showSeparator =
          ItemSeparatorComponent != null && !isLastIndex(entry.index);
        return (
          <ViewHolder
            key={entry.recyclerKey}
            index={entry.index}
            layout={getLayout(entry.index)}
            inverted={inverted}
            snapAlignment={snapAlignment}
            onMeasure={onMeasure}
          >
            {renderItemForIndex(entry.index)}
            {showSeparator ? <ItemSeparatorComponent /> : null}
          </ViewHolder>
        );
      })}
    </>
  );
}
